import type { ComparisonResult } from '@/types/consumer';

interface ComparisonSummaryProps {
  comparison: ComparisonResult;
  language: string;
  className?: string;
}

export function ComparisonSummary({
  comparison,
  language,
  className = '',
}: ComparisonSummaryProps) {
  const t = language === 'es';

  return (
    <div className={`card p-5 bg-surface-800/50 ${className}`}>
      <h3 className="text-sm font-medium text-text-tertiary uppercase tracking-wider mb-3">
        {t ? 'Resumen de Comparación' : 'Comparison Summary'}
      </h3>

      <ul className="space-y-2">
        {comparison.keyDifferences.map((diff, idx) => (
          <li key={idx} className="flex items-start gap-2 text-sm">
            <span className="mt-1 w-1.5 h-1.5 rounded-full bg-primary-400 flex-shrink-0" />
            <span className="text-text-secondary">{diff}</span>
          </li>
        ))}
      </ul>

      {/* Visual Comparison Bars */}
      <div className="mt-4 pt-4 border-t border-surface-700 space-y-3">
        <ComparisonBar
          label={t ? 'Sensibilidad al Precio' : 'Price Sensitivity'}
          valueA={comparison.priceSensitivityDiff > 0 ? 0.5 + comparison.priceSensitivityDiff / 2 : 0.5}
          valueB={comparison.priceSensitivityDiff < 0 ? 0.5 - comparison.priceSensitivityDiff / 2 : 0.5}
        />
        <ComparisonBar
          label={t ? 'Lealtad de Marca' : 'Brand Loyalty'}
          valueA={comparison.brandLoyaltyDiff > 0 ? 0.5 + comparison.brandLoyaltyDiff / 2 : 0.5}
          valueB={comparison.brandLoyaltyDiff < 0 ? 0.5 - comparison.brandLoyaltyDiff / 2 : 0.5}
        />
      </div>
    </div>
  );
}

// ============================================================================
// HELPER COMPONENTS
// ============================================================================

function ComparisonBar({
  label,
  valueA,
  valueB,
}: {
  label: string;
  valueA: number;
  valueB: number;
}) {
  return (
    <div>
      <div className="flex justify-between items-center mb-1">
        <span className="text-xs text-text-tertiary">{label}</span>
        <div className="flex gap-3 text-xs">
          <span className="text-primary-400">A</span>
          <span className="text-accent-teal">B</span>
        </div>
      </div>
      <div className="flex gap-1 h-2">
        <div
          className="bg-primary-500/60 rounded-l"
          style={{ width: `${valueA * 100}%` }}
        />
        <div
          className="bg-accent-teal/60 rounded-r"
          style={{ width: `${valueB * 100}%` }}
        />
      </div>
    </div>
  );
}
